// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1G35U","insightsList":"newBusinessInsightsMenu_insightsList__1g4Sc","active":"newBusinessInsightsMenu_active__2GNim"};